'use client';
import React, { useEffect, useState } from 'react';
import OtherCustomersProductsSectionMobile from './OtherCustomersProductsSectionMobile';
import { ProductBase } from '@/types/product';
import { OtherCustomersAlsoBought } from '@/types/strapi';
import { getProductsByIds } from '@/hooks/useProducts';
import Loader from '@/components/ui/Loader';

interface OtherProductsSectionMobileProps {
  onFavoriteToggle?: (id: string) => void;
  otherProducts: ProductBase[];
  otherCustomersData?: OtherCustomersAlsoBought | null;
}

const OtherProductsSectionMobile: React.FC<OtherProductsSectionMobileProps> = ({
  onFavoriteToggle,
  otherProducts,
  otherCustomersData,
}) => {
  const [strapiProducts, setStrapiProducts] = useState<ProductBase[]>([]);
  const [isLoadingStrapi, setIsLoadingStrapi] = useState(false);

  // Obtener productos de Strapi si hay datos disponibles
  useEffect(() => {
    const fetchStrapiProducts = async () => {
      if (!otherCustomersData?.productos || otherCustomersData.productos.length === 0) {
        return;
      }

      setIsLoadingStrapi(true);
      try {
        const productIds = otherCustomersData.productos.map((p) =>
          p.id_producto_prestashop.toString()
        );
        const fetchedProducts = await getProductsByIds(productIds);
        setStrapiProducts(fetchedProducts);
      } catch (error) {
        console.error('Error fetching other customers products:', error);
      } finally {
        setIsLoadingStrapi(false);
      }
    };

    fetchStrapiProducts();
  }, [otherCustomersData?.productos]);

  // Usar productos de Strapi si están disponibles, sino usar otherProducts
  const displayProducts = strapiProducts.length > 0 ? strapiProducts : otherProducts;
  const isLoading = isLoadingStrapi && strapiProducts.length === 0;

  if (isLoading) {
    return (
      <div data-component-id="src/components/sections/mobile/OtherProductsSectionMobile.tsx:53:6" data-component-path="src/components/sections/mobile/OtherProductsSectionMobile.tsx" data-component-line="53" data-component-file="OtherProductsSectionMobile.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20justify-center%20py-6%22%7D" className="flex justify-center py-6">
        <Loader data-component-id="src/components/sections/mobile/OtherProductsSectionMobile.tsx:54:8" data-component-path="src/components/sections/mobile/OtherProductsSectionMobile.tsx" data-component-line="54" data-component-file="OtherProductsSectionMobile.tsx" data-component-name="Loader" data-component-content="%7B%22elementName%22%3A%22Loader%22%7D" />
      </div>
    );
  }

  return (
    <OtherCustomersProductsSectionMobile data-component-id="src/components/sections/mobile/OtherProductsSectionMobile.tsx:60:4" data-component-path="src/components/sections/mobile/OtherProductsSectionMobile.tsx" data-component-line="60" data-component-file="OtherProductsSectionMobile.tsx" data-component-name="OtherCustomersProductsSectionMobile" data-component-content="%7B%22elementName%22%3A%22OtherCustomersProductsSectionMobile%22%7D"
      title="OTROS CLIENTES TAMBIÉN COMPRARON"
      subtitle="Seguro que te interesa"
      products={displayProducts}
    />
  );
};

export default OtherProductsSectionMobile;
